import {navigate} from '../../../../../utils/navigation';

export default () => {
    return (
        <div className="col invite" onClick={e => navigate('/invite')}>
            <div className="content">
                <div className="info">
                    <div className="title">Invite Friends</div>
                    <div className="text">Share your link and earn rewards</div>
                </div>

                <div className="invite-details">
                    <span>Earn 10%</span>
                    from friends
                </div>

                <div className="link">
                    Share link

                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <path d="M8.41797 3.45898L11.9588 6.99982L8.41797 10.5407" stroke="white" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M2.04199 7H11.8595" stroke="white" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </div>
            <div className="background">
                <div className="invite-bg"></div>
            </div>
        </div>
    )
}